import { objectFromKeyCollection, processResponse } from '../utils';

const getTenantProductFeatures = async (fetchGet, tenantFeaturesUrl) => {
  const result = await fetchGet(tenantFeaturesUrl);
  const response = await processResponse(result);
  return {
    features: objectFromKeyCollection(response, 'name'),
    raw: response
  };
};

export default getTenantProductFeatures;
//# sourceMappingURL=getTenantProductFeatures.js.map